module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<header class="modal-header">\n    <h2>'+
((__t=( t('restrictions::modal:title:filter')))==null?'':__t)+
'</h2>\n    <button type="button" class="btn btn-secondary" data-action="close">'+
((__t=( t('welcome::button:close')))==null?'':_.escape(__t))+
'</button>\n</header>\n\n<div class="modal-body">\n    <a href="/account/subscription" class="btn btn-primary">'+
((__t=(t('restrictions::modal:btn:upgrade')))==null?'':_.escape(__t))+
'</a>\n</div>\n\n<footer class="modal-footer">\n    <a href="/account/subscription">'+
((__t=(t('restrictions::modal:btn:plans-and-pricing')))==null?'':_.escape(__t))+
'</a>\n</footer>';
}
return __p;
};